import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-success-notice',
  templateUrl: './success-notice.component.html',
  styleUrls: ['./success-notice.component.scss'],
})
export class SuccessNoticeComponent {
  @Input() header: string = '';
  @Input() text: string = '';
}
